import { useEffect } from 'react';
import { useLoaderData, useNavigate } from 'react-router';

import { useJwt } from 'hooks/useJwt';

const RedirectToDashboard = () => {
	const data: any = useLoaderData();
	const navigate = useNavigate();
	const { setTokens } = useJwt();

	useEffect(() => {
		if (data.tokens) {
			setTokens(data.tokens);
		}
		if (!data.error) navigate('/dashboard', { replace: true });
	}, [data, setTokens, navigate]);

	if (data.error) {
		return <div>Sorry you cannot login at this time. Please contact support.</div>;
	}

	return <div>Please wait finishing login...</div>;
};

export default RedirectToDashboard;
